import {
  FLOW2_STEPS,
  FLOW2_TITLE,
  AVAIL_BASE_MESSAGE,
  NAME_INVALID_MESSAGE,
  NAME_MESSAGE,
  NAME_OTHER_MESSAGE,
  READY_MESSAGE,
  ROLE_MESSAGE,
  baptismMessage,
  welcomeMessage,
} from "./flow2Welcome";
import {
  ADAPT_MESSAGE,
  ADAPTED_MESSAGE,
  ALREADY_MESSAGE,
  ASK_MESSAGE,
  ACTIVITIES_MESSAGE,
  BLOCKAGE_MESSAGE,
  DIFFICULTY_MESSAGE,
  DURATION_MESSAGE,
  FLOW6_STEPS,
  FLOW6_TITLE,
  KEEP_MESSAGE,
  LATER_MESSAGE,
} from "./flow6Activities";
import {
  ACTIVE_MESSAGE,
  AVAIL_MESSAGE,
  CHOICE_MESSAGE,
  CONFIRM_MESSAGE,
  COURAGE_MESSAGE,
  FLOW4_STEPS,
  FLOW4_TITLE,
  GENERATE_MESSAGE,
  GOALS_MESSAGE,
  MODIFIED_MESSAGE,
  MODIFY_MESSAGE,
  PREVIEW_MESSAGE,
  REVIEW_MESSAGE,
  SAVED_MESSAGE,
} from "./flow4Planning";
import {
  ADVICE_MESSAGE,
  BALANCE_MESSAGE,
  ENCOURAGE_MESSAGE,
  FLOW7_STEPS,
  FLOW7_TITLE,
  NEXT_MESSAGE as PARENT_NEXT,
  PROGRESS_MESSAGE as PARENT_PROGRESS,
  REGULAR_MESSAGE,
  THANKS_MESSAGE,
  WEEKLY_NOTE,
  alertMessage,
  helloMessage,
  noteMessage,
  subjectsIntro,
} from "./flow7Parent";
import {
  AFTER_MESSAGE,
  ASK_MESSAGE as HELP_ASK,
  BLUR_MESSAGE,
  FLOW8_STEPS,
  FLOW8_TITLE,
  READ_MESSAGE,
  TUTOR_MESSAGE,
  helpCopy,
} from "./flow8PhotoHelp";
import { FLOW9_STEPS, FLOW9_TITLE, agendaCopy } from "./flow9Agenda";
import {
  AGAIN_MESSAGE,
  beginMessage,
  CHECK_MESSAGE,
  doneMessage,
  FLOW5_STEPS,
  FLOW5_TITLE,
  NOTE_MESSAGE,
  COLLECT_MESSAGE,
  NOTED_MESSAGE,
  OK_AGAIN_MESSAGE,
  OK_MESSAGE,
  PAUSE_MESSAGE,
  RATE_MESSAGE,
  RESUME_MESSAGE,
  SEND_MESSAGE,
  SENT_MESSAGE,
  SETTLED_MESSAGE,
  STARTED_MESSAGE,
  ASK_START_MESSAGE,
  REMINDER_MESSAGE,
} from "./flow5Sessions";
import {
  AFTER_MENTION,
  CONFIRM_INTRO,
  CONFIRM_OUTRO,
  DUE_PROMPT,
  DURATION_PROMPT,
  FLOW3_STEPS,
  FLOW3_TITLE,
  STEPS_PROMPT,
  SUBJECT_PROMPT,
  flow3Intro,
  RHYTHM_MESSAGE,
  typePrompt,
} from "./flow3Objectives";
import { PARENT_STEP_TITLES, PARENT_V0_MESSAGES } from "./flow1Parent";
import { ENGAGEMENT_MESSAGES } from "./flowEngagement";
import { FLOW10_STEPS, FLOW10_TITLE } from "./flow10Propose";
import { FLOW11_STEPS, FLOW11_TITLE, FLOW12_STEPS, FLOW12_TITLE, LOT3_MESSAGES } from "./flowLot3";
import { FLOW13_STEPS, FLOW13_TITLE, FLOW14_STEPS, FLOW14_TITLE, HOME_MESSAGES } from "./flowHome";
import { FLOW15_STEPS, FLOW15_TITLE, FLOW16_STEPS, FLOW16_TITLE, FLOW17_STEPS, FLOW17_TITLE, WEEK_MESSAGES } from "./flowWeek";
import { MVP_FLOWS, MVP_MESSAGES } from "./flowMvp";

/** Agent messages, the prompt that produces each one, and the default copy. */
export const FLOW_MESSAGES = [
  ...PARENT_V0_MESSAGES,
  ...ENGAGEMENT_MESSAGES,
  ...LOT3_MESSAGES,
  ...HOME_MESSAGES,
  ...WEEK_MESSAGES,
  ...MVP_MESSAGES,
  {
    key: "f2.welcome",
    flowId: 2,
    step: 0,
    label: "Message de bienvenue",
    prompt:
      "Accueille l'élève par son prénom dans l'application web. Présente-toi comme tuteur virtuel de Plan Étude. Dis que tu l'accompagnes dans son parcours scolaire pour mieux s'organiser, progresser à son rythme et rester motivé. Termine par une question : prêt(e) à commencer ? Ton chaleureux, tutoiement, un emoji.",
    text: ({ studentName }) => welcomeMessage(studentName),
  },
  {
    key: "f2.later",
    flowId: 2,
    step: 0,
    label: "Report",
    prompt:
      "L'élève a choisi de reporter. Rassure-le sans pression. Dis-lui de renvoyer « Oui, c'est parti ! » ou d'appuyer sur Rejouer quand il sera prêt.",
    text: ({ studentName }) =>
      `Pas de souci ${studentName} 🙂 Quand tu seras prêt·e, renvoie « Oui, c'est parti ! » ou appuie sur Rejouer.`,
  },
  {
    key: "f2.role",
    flowId: 2,
    step: 1,
    label: "Rôle du tuteur",
    prompt:
      "Explique le rôle du tuteur virtuel dans l'application web. Liste quatre aides : planifier les semaines, réviser, répondre aux questions, suivre les progrès. Invite l'élève à écrire à tout moment. Tutoiement, puces courtes.",
    text: () => ROLE_MESSAGE,
  },
  {
    key: "f2.ready",
    flowId: 2,
    step: 2,
    label: "Élève prêt",
    prompt:
      "Demande si l'élève est prêt à commencer l'accompagnement. Une question, ton encourageant.",
    text: () => READY_MESSAGE,
  },
  {
    key: "f2.avail",
    flowId: 2,
    step: 3,
    label: "Disponibilités de base",
    prompt:
      "Demande à l'élève de cocher ses heures disponibles de base pour étudier. Une phrase, tutoiement.",
    text: () => AVAIL_BASE_MESSAGE,
  },
  {
    key: "f2.name",
    flowId: 2,
    step: 4,
    label: "Nom du tuteur",
    prompt:
      "Invite l'élève à donner un prénom au tuteur. Dis que ce nom restera visible, seulement sur le compte de l'élève. Tutoiement, deux phrases.",
    text: () => NAME_MESSAGE,
  },
  {
    key: "f2.nameOther",
    flowId: 2,
    step: 4,
    label: "Autre prénom",
    prompt:
      "L'élève a choisi « Autre choix ». Demande quel prénom il veut te donner. Une question, tutoiement.",
    text: () => NAME_OTHER_MESSAGE,
  },
  {
    key: "f2.nameInvalid",
    flowId: 2,
    step: 4,
    label: "Prénom refusé",
    prompt:
      "Le prénom n'est pas acceptable. Demande un prénom simple, d'au moins deux lettres. Une phrase.",
    text: () => NAME_INVALID_MESSAGE,
  },
  {
    key: "f2.baptism",
    flowId: 2,
    step: 4,
    label: "Baptême",
    prompt:
      "Le tuteur adopte le prénom choisi par l'élève. Il se présente avec ce prénom, salue l'élève, et dit qu'on peut commencer. Deux phrases, tutoiement.",
    text: ({ tutorName, studentName }) => baptismMessage(tutorName, studentName),
  },
  {
    key: "f2.question",
    flowId: 2,
    step: 2,
    label: "Question libre",
    prompt:
      "L'élève a encore une question. Invite-le à l'écrire ici, précise que c'est une simulation, puis dis que l'accompagnement reprendra ensuite.",
    text: () =>
      "Bien sûr — pose ta question ici (simulation). Ensuite on pourra reprendre l’accompagnement.",
  },
  {
    key: "f2.resume",
    flowId: 2,
    step: 2,
    label: "Reprise après question",
    prompt:
      "Réponds brièvement à une question libre : on avance pas à pas et le plan reste modifiable. Propose de reprendre l'accompagnement.",
    text: () =>
      "Merci pour ta question (simulation). Voici une réponse courte : on avance pas à pas, et tu peux modifier ton plan à tout moment. Reprenons ?",
  },
  {
    key: "f2.nudge",
    flowId: 2,
    step: null,
    label: "Rappel des boutons",
    prompt:
      "L'élève a écrit librement pendant le parcours guidé. Rappelle-lui d'utiliser les boutons sous le message, ou de continuer une fois le parcours terminé.",
    text: () =>
      "Pour cette démo Flow 2, utilise les boutons sous le message — ou continue après la fin du parcours.",
  },
  {
    key: "f3.intro",
    flowId: 3,
    step: 0,
    label: "Ouverture",
    prompt:
      "Ouvre la collecte d'objectif. Salue l'élève par son prénom. Demande simplement le devoir, l'examen ou le projet à préparer. Dis que tu vas en faire un objectif clair. Tutoiement, message court.",
    text: ({ studentName }) => flow3Intro(studentName),
  },
  {
    key: "f3.rhythm",
    flowId: 3,
    step: 0,
    label: "Suivi et échéances",
    prompt:
      "Dis que l'élève peut écrire ce qu'il a ou prendre une photo de ses échéances. Annonce un suivi chaque jour pour chaque tâche. Dis que le mieux est de préparer la semaine le jeudi, avant la fin de semaine. Tutoiement, deux paragraphes.",
    text: () => RHYTHM_MESSAGE,
  },
  {
    key: "f3.after",
    flowId: 3,
    step: 1,
    label: "Accusé de la mention",
    prompt:
      "L'élève vient de mentionner un travail. Accuse réception en une phrase et annonce quelques questions pour comprendre et créer l'objectif.",
    text: () => AFTER_MENTION,
  },
  {
    key: "f3.subject",
    flowId: 3,
    step: 1,
    label: "Question matière",
    prompt:
      "Pose des questions simples pour créer l'objectif. La première question porte sur la matière. Termine par « Quelle matière concernée ? ».",
    text: () => SUBJECT_PROMPT,
  },
  {
    key: "f3.type",
    flowId: 3,
    step: 2,
    label: "Question type",
    prompt:
      "Confirme la matière choisie (« Parfait, c'est bien en {matière} ! ») puis demande le type de travail.",
    text: ({ subject }) => typePrompt(subject || "cette matière"),
  },
  {
    key: "f3.due",
    flowId: 3,
    step: 2,
    label: "Question échéance",
    prompt: "Demande la date d'échéance en une seule question simple.",
    text: () => DUE_PROMPT,
  },
  {
    key: "f3.duration",
    flowId: 3,
    step: 3,
    label: "Question durée",
    prompt:
      "Demande combien de temps l'élève pense devoir consacrer au travail. Ton encourageant, une question.",
    text: () => DURATION_PROMPT,
  },
  {
    key: "f3.steps",
    flowId: 3,
    step: 3,
    label: "Question étapes",
    prompt:
      "Propose de décrire des étapes spécifiques à prévoir. Précise que c'est facultatif. Une ou deux phrases.",
    text: () => STEPS_PROMPT,
  },
  {
    key: "f3.confirmIntro",
    flowId: 3,
    step: 4,
    label: "Confirmation",
    prompt:
      "Confirme que l'objectif est créé, avec une phrase d'ouverture juste avant la fiche récapitulative.",
    text: () => CONFIRM_INTRO,
  },
  {
    key: "f3.confirmOutro",
    flowId: 3,
    step: 4,
    label: "Rappels à venir",
    prompt:
      "Après la fiche, dis que l'objectif sera dans le plan et que des rappels aideront à avancer progressivement. Ton encourageant.",
    text: () => CONFIRM_OUTRO,
  },
  {
    key: "f3.done",
    flowId: 3,
    step: 4,
    label: "Après la création",
    prompt:
      "L'objectif est déjà créé et l'élève écrit encore. Dis-lui que c'est fait, et propose le sommaire ou Rejouer.",
    text: () =>
      "Ton objectif est créé (simulation). Choisis une étape dans le sommaire, ou appuie sur Rejouer.",
  },
  {
    key: "f3.nudge",
    flowId: 3,
    step: null,
    label: "Rappel des boutons",
    prompt:
      "L'élève a écrit librement là où la démo attend un bouton. Rappelle-lui d'utiliser les boutons sous le message.",
    text: () => "Pour cette démo Flow 3, utilise les boutons sous le message.",
  },
  {
    key: "f6.ask",
    flowId: 6,
    step: 0,
    label: "Demande de retour",
    prompt:
      "Après une séance de maths, demande comment elle s'est passée. Invite l'élève à dire ce qu'il a fait, le temps consacré et s'il a rencontré des difficultés. Un seul paragraphe, tutoiement.",
    text: () => ASK_MESSAGE,
  },
  {
    key: "f6.later",
    flowId: 6,
    step: 0,
    label: "Retour reporté",
    prompt:
      "L'élève reporte son retour. Rassure-le sans pression et dis-lui d'appuyer sur « Je fais un retour maintenant » quand il voudra.",
    text: () => LATER_MESSAGE,
  },
  {
    key: "f6.already",
    flowId: 6,
    step: 0,
    label: "Retour déjà fait",
    prompt:
      "L'élève dit qu'il a déjà fait son retour. Note-le en une phrase et dis que vous vous reparlez à la prochaine séance.",
    text: () => ALREADY_MESSAGE,
  },
  {
    key: "f6.activities",
    flowId: 6,
    step: 1,
    label: "Activités de la séance",
    prompt:
      "Demande ce que l'élève a fait pendant la séance et invite-le à choisir une ou plusieurs activités. Un seul paragraphe.",
    text: () => ACTIVITIES_MESSAGE,
  },
  {
    key: "f6.duration",
    flowId: 6,
    step: 2,
    label: "Temps consacré",
    prompt:
      "Demande combien de temps l'élève a travaillé et précise qu'il s'agit du temps de cette séance. Un seul paragraphe.",
    text: () => DURATION_MESSAGE,
  },
  {
    key: "f6.difficulty",
    flowId: 6,
    step: 3,
    label: "Difficulté",
    prompt:
      "Demande comment l'élève évalue la difficulté de la séance. Une seule question.",
    text: () => DIFFICULTY_MESSAGE,
  },
  {
    key: "f6.blockage",
    flowId: 6,
    step: 3,
    label: "Blocage",
    prompt:
      "Demande s'il a rencontré un blocage ou un point particulier. Une seule question.",
    text: () => BLOCKAGE_MESSAGE,
  },
  {
    key: "f6.adapt",
    flowId: 6,
    step: 4,
    label: "Adapter le plan",
    prompt:
      "Après la fiche de séance, demande s'il faut adapter le reste du plan. Propose d'ajouter une séance de révision sur les fractions cette semaine. Un seul paragraphe.",
    text: () => ADAPT_MESSAGE,
  },
  {
    key: "f6.adapted",
    flowId: 6,
    step: 4,
    label: "Plan adapté",
    prompt:
      "L'élève accepte l'adaptation. Confirme qu'une séance de révision sur les fractions est ajoutée cette semaine.",
    text: () => ADAPTED_MESSAGE,
  },
  {
    key: "f6.keep",
    flowId: 6,
    step: 4,
    label: "Plan inchangé",
    prompt:
      "L'élève ne veut pas modifier le plan. Confirme que le plan reste tel quel et salue la prochaine séance.",
    text: () => KEEP_MESSAGE,
  },
  {
    key: "f6.nudge",
    flowId: 6,
    step: null,
    label: "Rappel des boutons",
    prompt:
      "L'élève a écrit librement là où la démo attend un bouton. Rappelle-lui d'utiliser les boutons sous le message.",
    text: () => "Pour cette démo Flow 6, utilise les boutons sous le message.",
  },
  {
    key: "f5.remind",
    flowId: 5,
    step: 0,
    label: "Rappel",
    prompt:
      "Texto de rappel : l'élève s'était engagé(e) à étudier une tâche précise, avec la durée et la plage horaire d'aujourd'hui. Une phrase, tutoiement.",
    text: () => REMINDER_MESSAGE,
  },
  {
    key: "f5.askStart",
    flowId: 5,
    step: 0,
    label: "Commencer maintenant",
    prompt: "Demande si l'élève veut commencer maintenant. Une question courte.",
    text: () => ASK_START_MESSAGE,
  },
  {
    key: "f5.task",
    flowId: 5,
    step: 0,
    label: "Rappel",
    prompt:
      "Texto de rappel : l'élève s'était engagé(e) à étudier une tâche précise, avec la durée et la plage horaire d'aujourd'hui. Une phrase, tutoiement.",
    text: () => REMINDER_MESSAGE,
  },
  {
    key: "f5.begin",
    flowId: 5,
    step: 1,
    label: "Démarrage",
    prompt: "Confirme la tâche choisie et demande à l'élève de signaler le démarrage. Une phrase, tutoiement.",
    text: ({ task } = {}) => beginMessage(task),
  },
  {
    key: "f5.started",
    flowId: 5,
    step: 2,
    label: "Séance lancée",
    prompt: "Dis que la séance est partie à 18 h 00 et que tu restes avec l'élève. Une phrase.",
    text: () => STARTED_MESSAGE,
  },
  {
    key: "f5.check",
    flowId: 5,
    step: 2,
    label: "Suivi",
    prompt: "Demande si tout va bien. Une question courte.",
    text: () => CHECK_MESSAGE,
  },
  {
    key: "f5.ok",
    flowId: 5,
    step: 2,
    label: "Tout va bien",
    prompt: "L'élève dit que tout va bien. Encourage-le à continuer. Une phrase.",
    text: () => OK_MESSAGE,
  },
  {
    key: "f5.again",
    flowId: 5,
    step: 2,
    label: "Nouveau suivi",
    prompt: "Redemande si tout va toujours bien. Une question courte.",
    text: () => AGAIN_MESSAGE,
  },
  {
    key: "f5.okAgain",
    flowId: 5,
    step: 2,
    label: "Ça avance",
    prompt: "L'élève confirme encore que tout va bien. Dis qu'il avance bien. Une phrase.",
    text: () => OK_AGAIN_MESSAGE,
  },
  {
    key: "f5.pause",
    flowId: 5,
    step: 2,
    label: "Pause",
    prompt: "Confirme la pause à 18 h 20 et dis que le temps est arrêté. Une phrase.",
    text: () => PAUSE_MESSAGE,
  },
  {
    key: "f5.resume",
    flowId: 5,
    step: 2,
    label: "Reprise",
    prompt: "Confirme la reprise à 18 h 30 et dis que le temps repart. Une phrase.",
    text: () => RESUME_MESSAGE,
  },
  {
    key: "f5.done",
    flowId: 5,
    step: 2,
    label: "Temps calculé",
    prompt:
      "Annonce l'heure de fin et le temps calculé. S'il y a eu une pause, dis que ces minutes sont retirées. Une ou deux phrases.",
    text: ({ paused } = {}) => doneMessage(Boolean(paused)),
  },
  {
    key: "f5.noted",
    flowId: 5,
    step: 2,
    label: "Difficulté notée",
    prompt: "Confirme que la difficulté est notée et propose de continuer. Une phrase.",
    text: () => NOTED_MESSAGE,
  },
  {
    key: "f5.collect",
    flowId: 5,
    step: 2,
    label: "Collecte de l'info",
    prompt:
      "Dis que tu rassembles les infos de la séance : la tâche, le temps calculé et la difficulté. Une ou deux phrases.",
    text: () => COLLECT_MESSAGE,
  },
  {
    key: "f5.rate",
    flowId: 5,
    step: 3,
    label: "Difficulté",
    prompt:
      "Demande comment s'est passée la séance. 5 veut dire facile, 1 ou 0 veut dire difficile. Propose aussi de noter une difficulté s'il y en a eu une. Tutoiement, message court.",
    text: () => RATE_MESSAGE,
  },
  {
    key: "f5.note",
    flowId: 5,
    step: 3,
    label: "Note de difficulté",
    prompt: "Invite l'élève à noter la difficulté en une phrase.",
    text: () => NOTE_MESSAGE,
  },
  {
    key: "f5.send",
    flowId: 5,
    step: 4,
    label: "Envoi au tuteur",
    prompt:
      "Annonce l'envoi au tuteur : début, fin, temps passé, et comment s'est passée la séance. Une ou deux phrases.",
    text: () => SEND_MESSAGE,
  },
  {
    key: "f5.sent",
    flowId: 5,
    step: 4,
    label: "Infos envoyées",
    prompt: "Confirme que les infos sont envoyées au tuteur. Une phrase.",
    text: () => SENT_MESSAGE,
  },
  {
    key: "f5.settled",
    flowId: 5,
    step: null,
    label: "Après la séance",
    prompt:
      "La séance est déjà terminée et l'élève écrit encore. Dis-lui que c'est fait, et propose le sommaire ou Rejouer.",
    text: () => SETTLED_MESSAGE,
  },
  {
    key: "f5.nudge",
    flowId: 5,
    step: null,
    label: "Rappel des boutons",
    prompt:
      "L'élève a écrit librement là où la démo attend un bouton. Rappelle-lui d'utiliser les boutons sous le message.",
    text: () => "Pour cette démo Flow 5, utilise les boutons sous le message.",
  },
  {
    key: "f4.goals",
    flowId: 4,
    step: 0,
    label: "Objectifs de la semaine",
    prompt:
      "Rappelle les objectifs choisis et dis que tu vas les intégrer dans le plan de la semaine. Un seul paragraphe, tutoiement.",
    text: () => GOALS_MESSAGE,
  },
  {
    key: "f4.confirm",
    flowId: 4,
    step: 0,
    label: "Confirmation",
    prompt:
      "Demande si l'élève souhaite planifier ces objectifs pour la semaine à venir. Une question.",
    text: () => CONFIRM_MESSAGE,
  },
  {
    key: "f4.avail",
    flowId: 4,
    step: 1,
    label: "Disponibilités",
    prompt:
      "Demande quand l'élève est disponible pour étudier cette semaine. Il peut choisir ses créneaux ou dire ses habitudes. Un seul paragraphe.",
    text: () => AVAIL_MESSAGE,
  },
  {
    key: "f4.generate",
    flowId: 4,
    step: 2,
    label: "Génération",
    prompt:
      "Annonce que tu génères le plan à partir des objectifs et des disponibilités. Une phrase.",
    text: () => GENERATE_MESSAGE,
  },
  {
    key: "f4.preview",
    flowId: 4,
    step: 2,
    label: "Plan prêt",
    prompt: "Annonce que le plan de la semaine prochaine est prêt. Une phrase.",
    text: () => PREVIEW_MESSAGE,
  },
  {
    key: "f4.review",
    flowId: 4,
    step: 3,
    label: "Présentation du plan",
    prompt:
      "Présente le plan de la semaine prochaine et demande ce que l'élève en pense. Une ou deux phrases, un seul paragraphe.",
    text: () => REVIEW_MESSAGE,
  },
  {
    key: "f4.choice",
    flowId: 4,
    step: 3,
    label: "Valider ou modifier",
    prompt: "Demande s'il garde le plan ainsi ou s'il veut modifier quelque chose. Une question.",
    text: () => CHOICE_MESSAGE,
  },
  {
    key: "f4.modify",
    flowId: 4,
    step: 3,
    label: "Demande de modification",
    prompt:
      "Invite l'élève à dire ce qu'il veut ajuster : un horaire, une matière ou une durée. Une phrase.",
    text: () => MODIFY_MESSAGE,
  },
  {
    key: "f4.modified",
    flowId: 4,
    step: 3,
    label: "Modification notée",
    prompt: "Confirme que le samedi commence à 9 h. Une phrase.",
    text: () => MODIFIED_MESSAGE,
  },
  {
    key: "f4.active",
    flowId: 4,
    step: 4,
    label: "Plan activé",
    prompt:
      "Confirme que le plan d'étude est activé pour la semaine prochaine. Un seul paragraphe.",
    text: () => ACTIVE_MESSAGE,
  },
  {
    key: "f4.courage",
    flowId: 4,
    step: 4,
    label: "Encouragement",
    prompt: "Souhaite bon courage et des progrès pour la semaine. Une phrase.",
    text: () => COURAGE_MESSAGE,
  },
  {
    key: "f4.saved",
    flowId: 4,
    step: 4,
    label: "Plan consulté",
    prompt:
      "Rappelle le plan en une phrase : 6 séances, 5 h 30, 4 matières, adapté aux disponibilités.",
    text: () => SAVED_MESSAGE,
  },
  {
    key: "f4.nudge",
    flowId: 4,
    step: null,
    label: "Rappel des boutons",
    prompt:
      "L'élève a écrit librement là où la démo attend un bouton. Rappelle-lui d'utiliser les boutons sous le message.",
    text: () => "Pour cette démo Flow 4, utilise les boutons sous le message.",
  },
  {
    key: "f7.hello",
    flowId: 7,
    step: 0,
    label: "Résumé de la semaine",
    prompt:
      "Adresse-toi au parent. Résume la semaine de l'élève (prénom, Secondaire 3) et dis que c'est une bonne semaine dans l'ensemble. Vouvoiement, un seul paragraphe.",
    text: ({ studentName }) => helloMessage(studentName),
  },
  {
    key: "f7.weekly",
    flowId: 7,
    step: 0,
    label: "Rythme des résumés",
    prompt:
      "Dis au parent qu'il recevra un résumé chaque semaine et une alerte seulement en cas de besoin. Un seul paragraphe.",
    text: () => WEEKLY_NOTE,
  },
  {
    key: "f7.subjects",
    flowId: 7,
    step: 1,
    label: "Temps par matière",
    prompt:
      "Annonce le temps d'étude de l'élève pour la semaine du 9 au 15 octobre. Une phrase, vouvoiement.",
    text: ({ studentName }) => subjectsIntro(studentName),
  },
  {
    key: "f7.balance",
    flowId: 7,
    step: 1,
    label: "Équilibre",
    prompt:
      "Dis que l'équilibre est bon et que l'élève a bien travaillé en Maths et en Français. Un seul paragraphe.",
    text: () => BALANCE_MESSAGE,
  },
  {
    key: "f7.progress",
    flowId: 7,
    step: 2,
    label: "Progression",
    prompt:
      "Dis que les activités prévues cette semaine sont presque toutes complétées. Une phrase.",
    text: () => PARENT_PROGRESS,
  },
  {
    key: "f7.regular",
    flowId: 7,
    step: 2,
    label: "Régularité",
    prompt:
      "Souligne la régularité et encourage le parent à continuer ainsi. Un seul paragraphe, vouvoiement.",
    text: () => REGULAR_MESSAGE,
  },
  {
    key: "f7.alert",
    flowId: 7,
    step: 3,
    label: "Point d'attention",
    prompt:
      "Signale avec douceur que l'élève n'a pas terminé les exercices de fonctions en Maths prévus cette semaine. Un seul paragraphe.",
    text: ({ studentName }) => alertMessage(studentName),
  },
  {
    key: "f7.encourage",
    flowId: 7,
    step: 3,
    label: "Encouragement possible",
    prompt:
      "Demande au parent s'il souhaite encourager l'élève. Dis qu'un petit mot peut faire la différence. Un seul paragraphe.",
    text: () => ENCOURAGE_MESSAGE,
  },
  {
    key: "f7.advice",
    flowId: 7,
    step: 3,
    label: "Conseil",
    prompt:
      "Propose de suggérer à l'élève un moment calme ce week-end pour terminer. Un seul paragraphe.",
    text: () => ADVICE_MESSAGE,
  },
  {
    key: "f7.next",
    flowId: 7,
    step: 4,
    label: "Prochains objectifs",
    prompt: "Annonce les prochains objectifs pour la semaine du 16 au 22 octobre. Une phrase.",
    text: () => PARENT_NEXT,
  },
  {
    key: "f7.note",
    flowId: 7,
    step: 4,
    label: "Origine des objectifs",
    prompt:
      "Précise que ces objectifs ont été définis avec l'élève selon son plan d'apprentissage. Une phrase.",
    text: ({ studentName }) => noteMessage(studentName),
  },
  {
    key: "f7.thanks",
    flowId: 7,
    step: 4,
    label: "Remerciement",
    prompt:
      "Dis que le parent sera informé du bilan de la semaine prochaine et remercie-le pour son soutien. Un seul paragraphe.",
    text: () => THANKS_MESSAGE,
  },
  {
    key: "f7.nudge",
    flowId: 7,
    step: null,
    label: "Rappel des boutons",
    prompt:
      "Le parent a écrit librement là où la démo attend un bouton. Rappelle-lui d'utiliser les boutons sous le message.",
    text: () => "Pour cette démo Flow 7, utilise les boutons sous le message.",
  },
  {
    key: "f8.ask",
    flowId: 8,
    step: 0,
    label: "Demande d'aide",
    prompt:
      "Invite l'élève à envoyer une photo de l'exercice ou à dire ce qu'il ne comprend pas. Un seul paragraphe, tutoiement.",
    text: () => HELP_ASK,
  },
  {
    key: "f8.read",
    flowId: 8,
    step: 1,
    label: "Lecture de la photo",
    prompt:
      "Dis que tu regardes la photo avec l'élève. Un seul paragraphe, tutoiement.",
    text: () => READ_MESSAGE,
  },
  {
    key: "f8.prompt",
    flowId: 8,
    step: 1,
    label: "Matière reconnue",
    prompt:
      "Nomme la matière lue sur la photo, maths, et le thème : l'effet de la taille d'un échantillon sur la marge d'erreur. Demande ce qui bloque. Un seul paragraphe.",
    text: ({ item } = {}) => helpCopy(item, "prompt"),
  },
  {
    key: "f8.blur",
    flowId: 8,
    step: 1,
    label: "Photo floue",
    prompt:
      "La photo est illisible. Demande une photo plus nette ou la formule écrite. N'invente pas l'énoncé. Un seul paragraphe.",
    text: () => BLUR_MESSAGE,
  },
  {
    key: "f8.idea",
    flowId: 8,
    step: 2,
    label: "Idée principale",
    prompt:
      "Explique que plus on interroge de personnes, plus le résultat est précis. Utilise l'exemple de 30 % d'élèves qui aiment les maths. Un seul paragraphe.",
    text: ({ item } = {}) => helpCopy(item, "idea"),
  },
  {
    key: "f8.curve",
    flowId: 8,
    step: 2,
    label: "Courbe et question",
    prompt:
      "Compare 100 élèves (7,54 points) et 1 000 élèves (2,38 points). Dis que la courbe descend vite puis plus lentement. Demande comment rendre le sondage plus précis. Un seul paragraphe.",
    text: ({ item } = {}) => helpCopy(item, "curve"),
  },
  {
    key: "f8.choiceHint",
    flowId: 8,
    step: 2,
    label: "Indice échantillon",
    prompt:
      "La réponse est fausse. Rappelle que la marge baisse quand le nombre d'élèves augmente, sans donner la bonne lettre. Un seul paragraphe.",
    text: ({ item } = {}) => helpCopy(item, "choiceHint"),
  },
  {
    key: "f8.exact",
    flowId: 8,
    step: 2,
    label: "Bonne réponse",
    prompt:
      "Confirme qu'un plus grand échantillon réduit la marge, et que le gain ralentit ensuite. Propose la formule avec la racine carrée. Un seul paragraphe.",
    text: ({ item } = {}) => helpCopy(item, "exact"),
  },
  {
    key: "f8.formula",
    flowId: 8,
    step: 2,
    label: "Formule",
    prompt:
      "Reprends E = 1,645 × √(p̂(1 − p̂) / n). Nomme E, 1,645, p̂ = 0,30 et n. Un seul paragraphe.",
    text: ({ item } = {}) => helpCopy(item, "formula"),
  },
  {
    key: "f8.try",
    flowId: 8,
    step: 2,
    label: "À toi",
    prompt:
      "Rappelle le résultat vérifié pour 100 personnes, 7,54 %. Demande seulement combien vaut 0,21 ÷ 400. Un seul paragraphe.",
    text: ({ item } = {}) => helpCopy(item, "try"),
  },
  {
    key: "f8.divHint",
    flowId: 8,
    step: 2,
    label: "Indice division",
    prompt:
      "La réponse est fausse. Dis que 0,21 divisé par 400 est plus petit que 0,21 divisé par 100, sans donner 0,000525. Un seul paragraphe.",
    text: ({ item } = {}) => helpCopy(item, "divHint"),
  },
  {
    key: "f8.divOk",
    flowId: 8,
    step: 2,
    label: "Division juste",
    prompt:
      "Confirme 0,000525 et la marge d'environ 3,77 %. Dis qu'une seule image va garder la formule lisible. Un seul paragraphe.",
    text: ({ item } = {}) => helpCopy(item, "divOk"),
  },
  {
    key: "f8.fiche",
    flowId: 8,
    step: 3,
    label: "Résumé visuel",
    prompt:
      "Annonce l'image du résumé. Elle reprend la formule, le 7,54 % et le tableau de la photo. Un seul paragraphe.",
    text: ({ item } = {}) => helpCopy(item, "fiche"),
  },
  {
    key: "f8.after",
    flowId: 8,
    step: 3,
    label: "Après la fiche",
    prompt:
      "Propose de confirmer la compréhension, de demander un autre exemple, ou de parler à un tuteur. Une phrase.",
    text: () => AFTER_MESSAGE,
  },
  {
    key: "f8.understood",
    flowId: 8,
    step: 4,
    label: "Compris",
    prompt:
      "Félicite l'élève, propose de calculer 0,40 × 0,60 sans aide, et note que la marge d'erreur est comprise. Un seul paragraphe.",
    text: ({ item } = {}) => helpCopy(item, "understood"),
  },
  {
    key: "f8.again",
    flowId: 8,
    step: 4,
    label: "Autre exemple",
    prompt:
      "Propose un exemple avec p̂ = 0,50 et n = 100, et rappelle que la fiche reste dans la conversation. Un seul paragraphe.",
    text: ({ item } = {}) => helpCopy(item, "again"),
  },
  {
    key: "f8.tutor",
    flowId: 8,
    step: 4,
    label: "Tuteur",
    prompt:
      "Note la demande de tuteur et dis que la fiche reste dans la conversation. Un seul paragraphe.",
    text: () => TUTOR_MESSAGE,
  },
  {
    key: "f8.nudge",
    flowId: 8,
    step: null,
    label: "Rappel des boutons",
    prompt:
      "L'élève a écrit librement là où la démo attend un bouton ou une photo. Rappelle-lui les boutons.",
    text: () => "Pour cette démo Flow 8, utilise les boutons ou ajoute une photo.",
  },
  {
    key: "f9.ask",
    flowId: 9,
    step: 0,
    label: "Demande de photo",
    prompt:
      "Demande une seule photo : agenda de la semaine, une journée, ou la fiche d'un devoir. Un seul paragraphe.",
    text: () => agendaCopy("ask"),
  },
  {
    key: "f9.read",
    flowId: 9,
    step: 1,
    label: "Lecture de la photo",
    prompt:
      "Dis ce que la photo contient comme remises, sans inventer une date absente. Un seul paragraphe.",
    text: (ctx = {}) => agendaCopy("read", ctx),
  },
  {
    key: "f9.deadlines",
    flowId: 9,
    step: 2,
    label: "Échéances reconstruites",
    prompt:
      "Annonce les échéances remises en ordre, devoirs et examens séparés pour le plan. Un seul paragraphe.",
    text: () => agendaCopy("deadlines"),
  },
  {
    key: "f9.offer",
    flowId: 9,
    step: 2,
    label: "Proposition des plans",
    prompt:
      "Propose un plan d'étude différent par échéance, avec des séances avant la remise. Un seul paragraphe.",
    text: () => agendaCopy("offer"),
  },
  {
    key: "f9.plans",
    flowId: 9,
    step: 3,
    label: "Plans distincts",
    prompt:
      "Présente un plan par échéance. L'examen a plus de séances que le devoir. Un seul paragraphe.",
    text: () => agendaCopy("plans"),
  },
  {
    key: "f9.ready",
    flowId: 9,
    step: 3,
    label: "Plans prêts",
    prompt: "Dis que les plans restent séparés et peuvent être activés ensemble. Un seul paragraphe.",
    text: () => agendaCopy("ready"),
  },
  {
    key: "f9.done",
    flowId: 9,
    step: 4,
    label: "Plans activés",
    prompt: "Confirme l'activation, un plan par remise, et la possibilité d'ajouter une photo. Un seul paragraphe.",
    text: () => agendaCopy("done"),
  },
  {
    key: "f9.gap",
    flowId: 9,
    step: null,
    label: "Photo suivante",
    prompt: "Demande la photo suivante, une seule, pour les dates manquantes. Un seul paragraphe.",
    text: () => agendaCopy("gap"),
  },
  {
    key: "f9.blur",
    flowId: 9,
    step: null,
    label: "Photo illisible",
    prompt: "Dis que la date n'est pas assez claire et demande une autre photo. Un seul paragraphe.",
    text: () => agendaCopy("blur"),
  },
  {
    key: "f9.complete",
    flowId: 9,
    step: 4,
    label: "Agenda complet",
    prompt: "Confirme que les plans restent actifs. Un seul paragraphe.",
    text: () => agendaCopy("complete"),
  },
  {
    key: "f9.nudge",
    flowId: 9,
    step: null,
    label: "Rappel des boutons",
    prompt: "Rappelle les boutons de photo : semaine, journée ou fiche. Un seul paragraphe.",
    text: () => agendaCopy("nudge"),
  },
];

const byKey = new Map(FLOW_MESSAGES.map((message) => [message.key, message]));

export function getFlowMessage(key) {
  const message = byKey.get(key);
  if (!message) throw new Error(`Unknown flow message: ${key}`);
  return message;
}

export function nextFlowMessageKey(key) {
  const index = FLOW_MESSAGES.findIndex((item) => item.key === key);
  return FLOW_MESSAGES[index + 1]?.key || "";
}

export function messageText(key, ctx = {}) {
  return getFlowMessage(key).text(ctx);
}

export function promptGroups() {
  return [
    { flowId: 1, title: "Flow 1 — Accueil parent", steps: PARENT_STEP_TITLES },
    { flowId: 2, title: FLOW2_TITLE, steps: FLOW2_STEPS },
    { flowId: 3, title: FLOW3_TITLE, steps: FLOW3_STEPS },
    { flowId: 4, title: FLOW4_TITLE, steps: FLOW4_STEPS },
    { flowId: 5, title: FLOW5_TITLE, steps: FLOW5_STEPS },
    { flowId: 6, title: FLOW6_TITLE, steps: FLOW6_STEPS },
    { flowId: 7, title: FLOW7_TITLE, steps: FLOW7_STEPS },
    { flowId: 8, title: FLOW8_TITLE, steps: FLOW8_STEPS },
    { flowId: 9, title: FLOW9_TITLE, steps: FLOW9_STEPS },
    { flowId: 10, title: FLOW10_TITLE, steps: FLOW10_STEPS },
    { flowId: 11, title: FLOW11_TITLE, steps: FLOW11_STEPS },
    { flowId: 12, title: FLOW12_TITLE, steps: FLOW12_STEPS },
    { flowId: 13, title: FLOW13_TITLE, steps: FLOW13_STEPS },
    { flowId: 14, title: FLOW14_TITLE, steps: FLOW14_STEPS },
    { flowId: 15, title: FLOW15_TITLE, steps: FLOW15_STEPS },
    { flowId: 16, title: FLOW16_TITLE, steps: FLOW16_STEPS },
    { flowId: 17, title: FLOW17_TITLE, steps: FLOW17_STEPS },
    ...Object.entries(MVP_FLOWS).map(([flowId, item]) => ({ flowId: Number(flowId), ...item })),
  ].map((flow) => ({
    ...flow,
    steps: flow.steps.map((label, step) => ({
      step,
      label,
      messages: FLOW_MESSAGES.filter(
        (message) => message.flowId === flow.flowId && message.step === step
      ),
    })),
    extras: FLOW_MESSAGES.filter(
      (message) => message.flowId === flow.flowId && message.step == null
    ),
  }));
}
